import apiFetch from '../apiFetch'

export default function (dossierId, token, typeStepsCode) {
  return apiFetch({ endPoint: `Dossier/StepsCompleted?DossierId=${dossierId}&typeStepsCode=${typeStepsCode}`, method: 'PUT', body: null, token: token })
}
